import React, { useCallback } from 'react';
import { Field, FieldRenderProps, RenderableProps } from 'react-final-form';

import OfferTypeSelect, { OfferTypeSelectProps } from './OfferTypeSelect';

type OfferTypeSelectFieldProps = Omit<OfferTypeSelectProps, 'onChange' | 'value'> & {
  name: string;
  onChange?: (value: string | null) => void;
};

const OfferTypeSelectField = (props: OfferTypeSelectFieldProps) => {
  const renderInput = useCallback<NonNullable<RenderableProps<FieldRenderProps<string>>['render']>>(
    ({ input }) => (
      <OfferTypeSelect
        {...props}
        value={input.value}
        onChange={(value) => {
          input.onChange(value);

          if (props.onChange) {
            props.onChange(value);
          }
        }}
        items={props.items}
      />
    ),
    [props],
  );

  return <Field name={props.name} render={renderInput} type='text' />;
};

export default OfferTypeSelectField;
